import { Injectable } from '@jkhy/frontend-utils/di';
import { WiresClient } from '@treasury/api/channel';

@Injectable()
export class CorpayService {
    constructor(private readonly wiresClient: WiresClient) {}

    public async getSsoUrl(): Promise<string> {
        const response = await this.wiresClient.wiresGetCorpaySsoLogin();
        const url = response.data?.content;

        if (!url) {
            throw new Error('Invalid response from Corpay SSO endpoint.');
        }

        return url;
    }
}
